import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './auth.interceptor';
import { LocaleInterceptor } from './locale.interceptor';
import { LoggingInterceptor } from './logging.interceptor';
import { MaintenanceInterceptor } from './maintenance.interceptor';
// import { ResponseToCamelCaseInterceptor } from './response-to-camel-case.interceptor';

export const httpInterceptorsProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LocaleInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
  // Keep last: DI interceptors run in registration order, so the last one is
  // innermost and sees the raw backend error first.
  { provide: HTTP_INTERCEPTORS, useClass: MaintenanceInterceptor, multi: true },
];
